
import Paper from '@mui/material/Paper';
import { LOGO_ELEVE, LOGO_ELEVE_WHITE } from '../utils/constants';

export default function LogoEleve(props) {
    const { width, style, isWhite } = props;
    return <img alt="" src={(isWhite) ? LOGO_ELEVE_WHITE : LOGO_ELEVE} width={width} style={style} />
}